import React from "react";
import { Input, Row } from "reactstrap";
import { ColPrompt } from "./index";
import { ColValue, ErrorDiv } from "../ProductionModule/index";
import { useMachineSetupContextUpdater } from "./useMachineSetupContextUpdater";
import { useMachineSetupContextState } from "./useMachineSetupContextState";
// Used by the Mahan Oven

export default function RecipeRow() {
   const { handleInputRangeChange } = useMachineSetupContextUpdater();
   const { machineSetup, errorDivDefinitions } = useMachineSetupContextState();
   const defaultOnChangeVal = { target: { value: "" } };

   return (
      <Row className="mb-2">
         <ColPrompt title={"Recipe"} bold={true} description={"R"} sizeProp={3} />
         <ColValue size={4}>
            <Input
               type="text"
               style={{ borderRadius: "10px", fontSize: "14px" }}
               value={machineSetup.extendedPropertyJson.recipe || ""}
               onChange={(e) =>
                  e.target.value
                     ? handleInputRangeChange(e, 1, 50, "recipe", false, false, false)
                     : handleInputRangeChange(defaultOnChangeVal, 1, 50, "recipe", false, false, false)
               }
            />
            {errorDivDefinitions.recipe && (
               <ErrorDiv>1-50</ErrorDiv>
            )}
         </ColValue>
      </Row>
   );
}